var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center mb-3 pt-2 justify-between"},[_c('p',{staticClass:"text-sky-900 text-md font-semibold ml-1 mb-0"},[_vm._v(" "+_vm._s(_vm.title)+" "+_vm._s(_vm.dynamicTitle)+" ("+_vm._s(_vm.number.length)+") ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }